let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kUiwW")).then(() => parcelRequire('3kPYw'));